var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28996",
    "data-name": "Group 28996",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1533",
    "data-name": "Ellipse 1533",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "rgba(255,221,206,0.34)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rating_3_",
    "data-name": "rating (3)",
    transform: "translate(10.667 10.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26816",
    "data-name": "Group 26816",
    transform: "translate(11.223 0.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33495",
    "data-name": "Path 33495",
    d: "M160.8,17.22l-1.875,1.828a2.448,2.448,0,0,0-.7,2.167l.442,2.58a2.448,2.448,0,0,1-3.553,2.581l-2.317-1.218a2.446,2.446,0,0,0-2.279,0L148.2,26.377a2.448,2.448,0,0,1-3.553-2.581l.442-2.58a2.447,2.447,0,0,0-.7-2.167L142.51,17.22a2.448,2.448,0,0,1,1.357-4.176l2.591-.377a2.449,2.449,0,0,0,1.844-1.339l1.159-2.348a2.449,2.449,0,0,1,4.391,0l1.159,2.348a2.449,2.449,0,0,0,1.844,1.339l2.591.377A2.448,2.448,0,0,1,160.8,17.22Z",
    transform: "translate(-141.768 -7.616)",
    fill: "#f4c534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33496",
    "data-name": "Path 33496",
    d: "M145.715,17.538c.767,1.949,1.9,3.252,1.105,5.093s-.395,4.258,3.7,2.528L148.2,26.377a2.448,2.448,0,0,1-3.553-2.581l.443-2.58a2.447,2.447,0,0,0-.7-2.167L142.51,17.22a2.448,2.448,0,0,1,1.357-4.176l2.591-.377a2.449,2.449,0,0,0,1.844-1.339l1.159-2.348a2.42,2.42,0,0,1,2.2-1.365c-1.723,0-1.007,4.969-3.474,6.272S144.948,15.589,145.715,17.538Z",
    transform: "translate(-141.768 -7.616)",
    fill: "#fbb540"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26817",
    "data-name": "Group 26817",
    transform: "translate(0 11.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33497",
    "data-name": "Path 33497",
    d: "M20.77,139.515,19.6,140.659a1.533,1.533,0,0,0-.441,1.357l.277,1.616a1.533,1.533,0,0,1-2.225,1.616l-1.451-.763a1.532,1.532,0,0,0-1.427,0l-1.451.763a1.533,1.533,0,0,1-2.225-1.616l.277-1.616a1.533,1.533,0,0,0-.441-1.357l-1.174-1.145a1.533,1.533,0,0,1,.85-2.615l1.623-.236a1.534,1.534,0,0,0,1.155-.839l.726-1.47a1.533,1.533,0,0,1,2.75,0l.726,1.47a1.534,1.534,0,0,0,1.155.839l1.623.236A1.533,1.533,0,0,1,20.77,139.515Z",
    transform: "translate(-8.851 -133.5)",
    fill: "#f4c534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33498",
    "data-name": "Path 33498",
    d: "M11.323,139.714c.48,1.22,1.192,2.037.692,3.189s-.247,2.667,2.315,1.583l-1.451.763a1.533,1.533,0,0,1-2.225-1.616l.277-1.616a1.533,1.533,0,0,0-.441-1.357l-1.174-1.145a1.533,1.533,0,0,1,.85-2.615l1.623-.236a1.534,1.534,0,0,0,1.155-.839l.726-1.47a1.515,1.515,0,0,1,1.375-.855c-1.079,0-.63,3.112-2.175,3.928s-2.025,1.065-1.545,2.286Z",
    transform: "translate(-8.851 -133.5)",
    fill: "#fbb540"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26818",
    "data-name": "Group 26818",
    transform: "translate(31.586 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33499",
    "data-name": "Path 33499",
    d: "M390.514,5.165l-1.008.983a1.316,1.316,0,0,0-.379,1.166l.238,1.388a1.317,1.317,0,0,1-1.911,1.388l-1.246-.655a1.315,1.315,0,0,0-1.225,0l-1.246.655A1.317,1.317,0,0,1,381.825,8.7l.238-1.388a1.316,1.316,0,0,0-.379-1.166l-1.008-.983a1.317,1.317,0,0,1,.73-2.246l1.394-.2a1.317,1.317,0,0,0,.991-.72l.623-1.263a1.317,1.317,0,0,1,2.362,0L387.4,2a1.317,1.317,0,0,0,.991.72l1.394.2a1.317,1.317,0,0,1,.73,2.246Z",
    transform: "translate(-380.277 0)",
    fill: "#f4c534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33500",
    "data-name": "Path 33500",
    d: "M382.4,5.336c.412,1.048,1.024,1.749.594,2.739s-.212,2.29,1.988,1.36l-1.246.655A1.317,1.317,0,0,1,381.825,8.7l.238-1.388a1.316,1.316,0,0,0-.379-1.166l-1.008-.983a1.317,1.317,0,0,1,.73-2.246l1.394-.2a1.317,1.317,0,0,0,.991-.72l.623-1.263A1.3,1.3,0,0,1,385.595,0c-.927,0-.542,2.672-1.868,3.373S381.987,4.288,382.4,5.336Z",
    transform: "translate(-380.277 0)",
    fill: "#fbb540"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26820",
    "data-name": "Group 26820",
    transform: "translate(11.489 11.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33501",
    "data-name": "Path 33501",
    d: "M166.111,171.551c6.515,0,10.2-6.668,10.2-12.4V154.41a2.668,2.668,0,0,0-5.336,0v-2.844a2.668,2.668,0,1,0-5.336,0v-.27a2.668,2.668,0,0,0-5.336,0v-9.34a2.668,2.668,0,0,0-5.336,0v12.555a9.162,9.162,0,0,0-1.142-2.741,3.046,3.046,0,0,0-5.328,2.955c.782,1.41.785,4.566.785,4.6v3.255a8.969,8.969,0,0,0,8.969,8.969Z",
    transform: "translate(-148.111 -139.29)",
    fill: "#ffddce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26819",
    "data-name": "Group 26819",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33502",
    "data-name": "Path 33502",
    d: "M167.982,285.97a8.82,8.82,0,0,0,2.781-.439,8.7,8.7,0,0,1-4.652,1.316h-7.863a8.969,8.969,0,0,1-8.969-8.969v-3.255c0-.036,0-3.191-.784-4.6a3.047,3.047,0,0,1,2.382-4.51,3.048,3.048,0,0,0-.512,3.634c.783,1.41.784,4.565.784,4.6V277a8.969,8.969,0,0,0,8.969,8.969h7.864Z",
    transform: "translate(-148.112 -254.585)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33503",
    "data-name": "Path 33503",
    d: "M289.8,254.318a.887.887,0,0,0,.887-.887v-3.593a2.669,2.669,0,0,1,1.781-2.516,2.668,2.668,0,0,0-3.554,2.516v3.593A.887.887,0,0,0,289.8,254.318Z",
    transform: "translate(-276.725 -237.833)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33504",
    "data-name": "Path 33504",
    d: "M413.084,286.705a.887.887,0,0,0,.887-.887h0a2.669,2.669,0,0,1,1.781-2.516,2.668,2.668,0,0,0-3.554,2.516h0A.886.886,0,0,0,413.084,286.705Z",
    transform: "translate(-389.339 -270.699)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33505",
    "data-name": "Path 33505",
    d: "M351.442,257.441a.887.887,0,0,0,.887-.887v-3.593a2.669,2.669,0,0,1,1.781-2.516,2.668,2.668,0,0,0-3.554,2.516v3.593A.886.886,0,0,0,351.442,257.441Z",
    transform: "translate(-333.033 -240.686)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33506",
    "data-name": "Path 33506",
    d: "M228.158,161.074a.887.887,0,0,0,.887-.887V141.959a2.669,2.669,0,0,1,1.781-2.516,2.668,2.668,0,0,0-3.554,2.516v18.228A.886.886,0,0,0,228.158,161.074Z",
    transform: "translate(-220.42 -139.291)",
    fill: "#ffcbbe"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.55ca9ca4a25f04d28d722b453f74791d.svg";
export { ForwardRef as ReactComponent };